import { currentLanguage, say } from "./say.ts";

const DAY = 86_400_000;

export function howLongAgo(said: string | Date): string {
  const days = Math.floor((Date.now() - new Date(said).getTime()) / DAY);
  if (days <= 0) return say("when.today");
  if (days === 1) return say("when.yesterday");
  if (days < 30) return say("when.daysAgo")(days);
  if (days < 365) return say("when.monthsAgo")(Math.max(1, Math.floor(days / 30)));
  return say("when.yearsAgo")(Math.max(1, Math.floor(days / 365)));
}

export function friendlyWhen(said: string | Date, now = new Date()): string {
  const at = new Date(said);
  if (Number.isNaN(at.getTime())) return "";
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  const then = new Date(at.getFullYear(), at.getMonth(), at.getDate()).getTime();
  const days = Math.round((today - then) / DAY);
  if (days <= 0) return at.toLocaleTimeString(currentLanguage(), { hour: "2-digit", minute: "2-digit" });
  if (days === 1) return say("when.yesterday");
  if (days < 30) return say("when.daysAgo")(days);
  if (at.getFullYear() === now.getFullYear()) {
    return at.toLocaleDateString(currentLanguage(), { month: "short", day: "numeric" });
  }
  return at.toLocaleDateString(currentLanguage(), { month: "short", day: "numeric", year: "numeric" });
}

export function exactWhen(said: string | Date): string {
  const at = new Date(said);
  if (Number.isNaN(at.getTime())) return "";
  return at.toLocaleString(currentLanguage(), {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatTime(said: string | Date): string {
  const at = new Date(said);
  if (Number.isNaN(at.getTime())) return "";
  return at.toLocaleTimeString(currentLanguage(), { hour: "2-digit", minute: "2-digit" });
}

export function formatDate(said: string | Date, options: Intl.DateTimeFormatOptions = {}): string {
  const at = new Date(said);
  if (Number.isNaN(at.getTime())) return "";
  return at.toLocaleDateString(currentLanguage(), options);
}

export function formatDateTime(said: string | Date): string {
  const at = new Date(said);
  return Number.isNaN(at.getTime()) ? "" : at.toLocaleString(currentLanguage());
}

export function formatList(items: readonly string[]): string {
  return new Intl.ListFormat(currentLanguage(), { style: "long", type: "conjunction" }).format(items);
}

export function pluralCategory(value: number): Intl.LDMLPluralRule {
  return new Intl.PluralRules(currentLanguage()).select(value);
}

export function relativeTime(value: number, unit: Intl.RelativeTimeFormatUnit): string {
  return new Intl.RelativeTimeFormat(currentLanguage(), { numeric: "auto" }).format(value, unit);
}
